import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const switchStyle = (disabled?: boolean) => css`
  display: inline-flex;
  align-items: center;
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  opacity: ${disabled ? 0.5 : 1};

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
  }
`;

/* 36×20 고정 크기 컨트롤. 노브 지름 16 + 여백 2. */
export const switchTrackStyle = (checked: boolean) => css`
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: ${theme.radius.pill}px;
  background: ${checked ? theme.color.primary : theme.color.border};
  transition: background 0.15s ease;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${checked ? '18px' : '2px'};
    width: 16px;
    height: 16px;
    border-radius: ${theme.radius.pill}px;
    background: ${theme.color.surface};
    transition: left 0.15s ease;
  }
`;
